
import {useState, useEffect, createContext} from 'react';
import React, {Component} from "react";
export const GeneralFunctionsContext = createContext();
export function GeneralFunctionsProvider ({children})  {
    const[innerWidth,setInnerWidth] = useState(0);
    const [offset, setOffset] = useState(0);

    useEffect(()=>{
        function handleResize() {
            setInnerWidth(window.innerWidth);
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    },[])
 

    //Convert Bytes
    const getFormattedBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    const initOnPageScroll=()=>{
        // Scroll to top on mount
        window.scrollTo(0, 0);

        // Scroll handler function
        const handleScroll = () => {
        setOffset(window.pageYOffset);
        };

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Cleanup function to remove listener on unmount
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }


    useEffect(() => {
        initOnPageScroll()
    }, []);


    return (
        <GeneralFunctionsContext.Provider value={{innerWidth, offset}}>
            {children} 
        </GeneralFunctionsContext.Provider>
    )
}